<template>
  <AgTooltip v-if="temTooltip" :location="tooltipDirection">
    <template #activator="{ props }">
      <v-btn
        :id="id"
        v-bind="props"
        class="ag-btn-icon"
        variant="text"
        icon
        :class="{ 'v-btn--active': active }"
        :data-size="size"
        :disabled="disabled"
        :loading="loading"
        :to="to"
        :type="submit ? 'submit' : 'button'"
        @click="onClick"
      >
        <v-badge dot :model-value="showBadge">
          <AGIcon :icon="icon" :size="iconSize" :color="iconColor" />
        </v-badge>
      </v-btn>
    </template>

    {{ tooltip }}
  </AgTooltip>

  <v-btn
    v-else
    :id="id"
    class="ag-btn-icon"
    variant="text"
    icon
    :class="{ 'v-btn--active': active }"
    :data-size="size"
    :disabled="disabled"
    :loading="loading"
    :to="to"
    :type="submit ? 'submit' : 'button'"
    @click="onClick"
  >
    <v-badge dot :model-value="showBadge">
      <AGIcon :icon="icon" :size="iconSize" :color="iconColor" />
    </v-badge>
  </v-btn>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
import AgTooltip from '@/components/common/AGTooltip.vue';
import { uniqueId } from 'lodash';

export default {
  emits: ['click'],
  components: {
    AgTooltip,
    AGIcon,
  },

  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: uniqueId('ag_btn_icon_'),
    },

    tooltip: {
      type: String,
      default: '',
    },

    tooltipDirection: {
      type: String,
      default: 'top',
      validator: (val) => ['top', 'bottom', 'left', 'right'].includes(val),
    },

    icon: {
      type: String,
      default: '',
    },

    iconSize: {
      type: String,
      required: false,
    },

    iconColor: {
      type: String,
      required: undefined,
    },

    size: {
      type: String,
      default: 'xl',
      validator(value) {
        return ['xl', 'lg', 'md', 'sm'].includes(value);
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    to: {
      type: [String, Object],
      default: undefined,
    },

    submit: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    showBadge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    temTooltip() {
      return this.tooltip !== '';
    },
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/btn.scss';
</style>
